
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cannabis-store/[slug]/menu",
      function () {
        return require("private-next-pages/cannabis-store/[slug]/menu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cannabis-store/[slug]/menu"])
      });
    }
  